import getUserAgent from 'helpers/getUserAgent';

const isIPhone = (req) => /iPhone/i.test(getUserAgent(req) || '');

export default isIPhone;
